import { startCase } from "es-toolkit/compat";

/**
 * Start cases a given string. Start casing is simply capitalizing the first
 * letter of each word. Use when you need to deal with unpredictable string
 * formats and don't need to worry about grammar.
 *
 * If you need to follow grammatical rules, you should use `toTitleCaseString()` instead.
 *
 * @param string string to be formatted
 * @returns a start cased string
 */
export const toStartCaseString = (string?: string): string => startCase(string);
